function removeDuplicate<T>(arr: T[]): T[] {
  const set = new Set(arr);
  return Array.from(set);
}

function isSetEqual<T>(set1: Set<T>, set2: Set<T>): boolean {
  return set1.size === set2.size && Array.from(set1).every((x) => set2.has(x));
}

export function hasSameElements<T>(arr1: T[], arr2: T[]) {
  return isSetEqual(new Set(arr1), new Set(arr2));
}

export default {
  removeDuplicate,
  isSetEqual,
  hasSameElements,
};
